"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDirection = calculateDirection;
exports.default = void 0;
exports.getTurfDirection = getTurfDirection;
var _geographiclib = _interopRequireDefault(require("geographiclib"));
var _bearing = _interopRequireDefault(require("@turf/bearing"));
var _mapUtilsMisc = require("./mapUtilsMisc");
var _config = require("./config");
var _UnknownDistanceAlgorithmError = _interopRequireDefault(require("../ErrorClasses/UnknownDistanceAlgorithmError"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const geod = _geographiclib.default.Geodesic.WGS84;

// Taken from https://github.com/Turfjs/turf/blob/5a029b206c832d11e7a6a2d3e16e57628ae14ffb/packages/turf-helpers/index.ts#L688
function bearingToAzimuth(bearing) {
  let angle = bearing % 360;
  if (angle < 0) {
    angle += 360;
  }
  return angle;
}
function getTurfDirection(fromCoords, toCoords) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    useNegatives = true,
    reverse = true
  } = options;
  const bearing = (0, _bearing.default)((0, _mapUtilsMisc.formatCoords)(fromCoords, reverse), (0, _mapUtilsMisc.formatCoords)(toCoords, reverse));

  // Bearing is a number between -180 and 180
  if (useNegatives) {
    return bearing;
  }
  // Will return a number between 0 and 360
  return bearingToAzimuth(bearing);
}
const getGeodCoords = (coords1, coords2) => {
  return [...(0, _mapUtilsMisc.formatCoords)(coords1, true), ...(0, _mapUtilsMisc.formatCoords)(coords2, true)];
};
function getGeodDirection(currentCoords, otherCoords, options) {
  const {
    useNegatives = true
  } = options;
  // expects y1, x1, y2, x2, so we always reverse (even if redundent)
  const r = geod.Inverse(...getGeodCoords(currentCoords, otherCoords));
  if (useNegatives) {
    return r.azi1;
  }
  return bearingToAzimuth(r.azi1);
}
function getDirectionFromAlgo(currentCoords, otherCoords, options) {
  const {
    algorithm = _config.GEO_ALGORITHMS.GEOD // TODO: Make sure this changes for scanline
  } = options;
  switch (algorithm) {
    case _config.GEO_ALGORITHMS.TURF:
      return getTurfDirection(currentCoords, otherCoords, options);
    case _config.GEO_ALGORITHMS.GEOD:
      return getGeodDirection(currentCoords, otherCoords, options);
    default:
      throw new _UnknownDistanceAlgorithmError.default(`Unkown algorithm "${algorithm}"`);
  }
}
function calculateDirection(currentCoords, otherCoords) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    reverse = true
  } = options;
  // Note that "from" is ignored from "options" as it is implied from the algorithm
  const direction = getDirectionFromAlgo((0, _mapUtilsMisc.formatCoords)(currentCoords, reverse), (0, _mapUtilsMisc.formatCoords)(otherCoords, reverse), options);
  return direction;
}
var _default = calculateDirection;
exports.default = _default;